import React, { Component } from "react";

export default class Header extends Component {
	render(){
		return(
			<div className="header">
				<span>CODENAMES</span>
			</div>
		);
	};
};

